export default __webpack_public_path__ + "static/media/reading.2e2874f0.svg";